<template>
  <div class="container home_six-feature-wrap style-two">
    <div class="row align-items-center">
      <div class="col-lg-6 pe-xxl-0">
        <div class="feature-content">
          <h2 class="section-title">Mazii Is The Global Couples Connection App</h2>
          <p>
            Mazii connects couples worldwide through beautiful, personalized widgets. Share love, celebrate moments, and stay close no matter the distance with our innovative relationship technology.
          </p>
          <div class="feature-item-wrap">
            <div class="feature-item d-flex">
              <span
                class="feature-icon d-flex flex-column justify-content-center align-items-center transition rounded-circle"
              >
                <img src="../../assets/img/icons/support-2.svg" alt="Image" />
              </span>
              <div class="feature-info">
                <h3 class="fs-20">24/7 Online Support</h3>
                <p>
                  State burst think end are its. Arrived off she elderly beloved
                  him affixed noisier yet. Course regard to up he hardly.
                </p>
              </div>
            </div>
            <div class="feature-item d-flex">
              <span
                class="feature-icon d-flex flex-column justify-content-center align-items-center transition rounded-circle"
              >
                <img src="../../assets/img/icons/group.svg" alt="Image" />
              </span>
              <div class="feature-info">
                <h3 class="fs-20">Online Community</h3>
                <p>
                  State burst think end are its. Arrived off she elderly beloved
                  him affixed noisier yet. Course regard to up he hardly.
                </p>
              </div>
            </div>
          </div>
          <div class="counter-card-wrap d-flex flex-wrap">
            <div class="counter-card position-relative">
              <h2>$<span class="counter">224</span>K+</h2>
              <p class="mb-0">Amount Raised</p>
            </div>
            <div class="counter-card position-relative">
              <h2><span class="counter">98.05</span>%</h2>
              <p class="mb-0">Happy User</p>
            </div>
            <div class="counter-card position-relative">
              <h2><span class="counter">751</span>M</h2>
              <p class="mb-0">Downloaded</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="feature-img">
          <img
            src="../../assets/img/home-one/about/about-img.webp"
            alt="Image"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorldwideUserManagementApp",
};
</script>

<style lang="scss" scoped>
.home_six-feature-wrap {
  .feature-content {
    .section-title {
      margin-bottom: 25px;
    }
    .feature-item-wrap {
      margin-top: 45px;
      margin-bottom: 45px;
      .feature-item {
        margin-bottom: 17px;
        &:last-child {
          margin-bottom: 0;
        }
        .feature-icon {
          width: 65px;
          height: 65px;
          background-color: var(--magnoliaColor);
        }
        .feature-info {
          width: calc(100% - 85px);
          margin-left: 20px;
          h3 {
            margin-bottom: 13px;
          }
        }
      }
    }
    .counter-card-wrap {
      .counter-card {
        width: 33.33%;
        &:after {
          position: absolute;
          top: 50%;
          content: "";
          width: 1px;
          height: 54px;
          transform: translateY(-50%);
          background: rgba(0, 0, 0, 0.12);
        }
        &:nth-child(1) {
          &:after {
            right: 12px;
          }
        }
        &:nth-child(2) {
          padding-left: 45px;
          &:after {
            right: -9px;
          }
        }
        &:nth-child(3) {
          padding-left: 65px;
          &:after {
            display: none;
          }
        }
        h2 {
          font-size: 30px;
          line-height: 1;
          font-weight: 700;
          margin-bottom: 8px;
          letter-spacing: -0.6px;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .home_six-feature-wrap {
    .feature-content {
      .feature-item-wrap {
        margin: 25px 0;
      }
      .counter-card-wrap {
        .counter-card {
          width: 50%;
          margin-bottom: 20px;
          &:nth-child(1) {
            &:after {
              right: 5px;
            }
          }
          &:nth-child(2) {
            padding-left: 55px;
            &:after {
              right: -27px;
            }
          }
          &:nth-child(3) {
            padding-left: 0;
            margin-bottom: 0;
            &:after {
              display: none;
            }
          }
          h2 {
            font-size: 22px;
            margin-bottom: 5px;
            span {
              font-size: 22px;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .home_six-feature-wrap {
    .feature-content {
      margin-top: 30px;
    }
  }
}

@media only screen and (min-width: 1400px) {
  .home_six-feature-wrap {
    .feature-img {
      width: calc(100% + 20px);
    }
    .feature-content {
      width: calc(100% - 95px);
      margin-left: auto;
    }
    &.style-two {
      .feature-content {
        margin-right: auto;
        margin-left: 0;
      }
    }
  }
}
</style>